import { render, staticRenderFns } from "./SchoolDetailPage.vue?vue&type=template&id=11c005c5&scoped=true&"
import script from "./SchoolDetailPage.vue?vue&type=script&lang=ts&"
export * from "./SchoolDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolDetailPage.vue?vue&type=style&index=0&id=11c005c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c005c5",
  null
  
)

export default component.exports